import React from 'react'
import Sheet from '@mui/joy/Sheet'
import AspectRatio from '@mui/joy/AspectRatio'

export const TemplatePreview = ({ img, isSelected, onClick }) => {
    return (
        <Sheet variant={isSelected ? 'outlined' : 'plain'} sx={{ p: 1 }}>
            <AspectRatio
                ratio="1/1"
                sx={{
                    width: '100%',
                }}
            >
                <img src={img} onClick={onClick} />
            </AspectRatio>
        </Sheet>
    )
}
